import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    isOpen: false,
    fileId: null,
    fileIds: [],
    blurVerdicts: {},
};
export const viewMediaModalSlice = createSlice({
    name: "viewMediaModal",
    initialState,
    reducers: {
        // The surrounding list is optional: a file opened on its own steps nowhere, unless the last list still
        // holds it, as when Back returns to a file the user left through a link.
        openViewMediaModal: (state, action) => {
            const { fileId, fileIds, blurVerdicts } = action.payload;
            state.isOpen = true;
            state.fileId = fileId;
            state.fileIds = fileIds ?? (state.fileIds.includes(fileId) ? state.fileIds : []);
            // A chat resolved a verdict for every file in its list; a gallery tile or a link resolved none. Replaced
            // whole on each open, so a verdict never outlives the surface that made it.
            state.blurVerdicts = blurVerdicts ?? {};
        },
        // Stepping keeps the list: only which file is current changes.
        setViewMediaModalFileId: (state, action) => {
            state.fileId = action.payload;
        },
        // The list outlives the close for the reopen above; nothing reads it while the modal is closed.
        closeViewMediaModal: (state) => {
            state.isOpen = false;
            state.fileId = null;
            state.blurVerdicts = {};
        },
    },
});
export const { closeViewMediaModal, openViewMediaModal, setViewMediaModalFileId } = viewMediaModalSlice.actions;
export default viewMediaModalSlice.reducer;
